// plan
export const plan_url = "/plan";
export const plans_delete = "/plan/delete";
export const draftPlansGet = "plan/draft/all";

//addon draft
export const draftAddonsGetEndpoint = "/addon/draft/getall";
export const draftAddonsAddEndpoint = "/addon/draft/add";
export const draftAddonsUpdateEndpoint = "/addon/draft/update";
export const draftAddonsDeleteEndpoint = "/addon/draft/delete";

// centralised PT plan (new isolated feature — writes to addon_master_draft via dedicated controller)
export const centralizedPtPlanDraftGet = "/centralized-pt-plan/draft";
export const centralizedPtPlanDraftAdd = "/centralized-pt-plan/draft";
export const centralizedPtPlanDraftUpdate = "/centralized-pt-plan/draft";
export const centralizedPtPlanDraftDelete = "/centralized-pt-plan/draft";
export const centralizedPtPlanMap = "/centralized-pt-plan/map";
export const centralizedPtPlanMappedGyms = "/centralized-pt-plan/mapped-gyms";
export const centralizedPtPlanUnmap = "/centralized-pt-plan/unmap";

// addon
export const addonCategoryEndPoint = "/addoncat";
export const getAddonEndpoint = "/addon";
export const createAddonEndPoint = "/addon/web";
export const updateAddonEndPoint = "/addon/web/update";
export const deleteAddonEndpoint = "/addon/delete";

// session and addon
export const sessionAddonGet = "/session/addon";

// pt-incentive-draft
export const ptIncentiveDraftGet = "/ptIncentive/draft/";
export const ptIncentiveDraftCreate = "/ptIncentive/draft/add";
export const ptIncentiveDraftUpdate = "/ptIncentive/draft/update";
export const ptIncentiveDraftDelete = "/ptIncentive/draft/delete";
export const ptIncentiveDraftMap = "/ptIncentive/draft/map";
export const ptIncentiveDraftMapUpdate = "/ptIncentive/draft/map/update";

// pt-incentive
export const ptIncentiveGet = "/ptIncentive/";

// trainers
export const trainersGet = "/trainer";
export const trainersV2Get = "/trainer/v2";
export const trainerEndpoint = "/trainer";
export const trainerLevelEndpoint = "/get_level";
export const trainerShift = "/trainerShift/getShiftSlots";
export const trainerOccupency = "/pt/trainer_occupancy_table";

export const trainerfeedbacksGet = "/trainer/feedback";
export const updateTrainer = "/trainer/update";

export const draftOfferCreate = "/offer/draft/add";
export const draftOfferUpdate = "/offer/draft/update";
export const draftOfferGet = "/offer/draft/getall";
export const draftOfferDelete = "/offer/draft/delete";

export const offerMapCreate = "/offer/map";
export const offerMapUpdate = "/offer/map/update";
export const offerMapGet = "/offer";

// WORKOUTS
export const workoutMappingGet = "/workoutmapping";
export const workoutexpGet = "/workoutmapping/workoutexp";

export const workoutCategoryGet = "/workoutcategory";
export const workoutCategoryCreate = "/workoutcategory/add";
export const workoutCategoryUpdate = "/workoutcategory/update";
export const workoutCategoryDelete = "/workoutcategory/delete";

export const workoutPackagesGet = "/workoutpackage/web";
export const workoutPackageCreate = "/workoutpackage/add/new";
export const workoutPackageDelete = "/workoutpackage/delete";
export const workoutPackageUpdate = "/workoutpackage/update";
export const workoutMappingCreate = "/workoutpackage/mapping/new";
export const workoutMappingStatsGet = "/workoutmapping/stats/pt";

export const workoutGet = "/workout";
export const workoutCreate = "/workout/add";
export const workoutUpdate = "/workout/v2/update";
export const workoutDelete = "/workout/delete";

// subscription
export const subscriptionGetById = "/subscription/getbygymid";
export const subscriptionsGetById = "/subscription/getbyid";
export const subscriptionPartialGet = "/subscription/partial";
export const subscriptions = "/subscription";
export const subscriptionMember = "/subscription/member";
export const subsDraftOrderPost = "/subscription/draftorder/cashfree";
export const subsAddCreate = "/subscription/add";

// cash verification
export const cashVerifyGenerate = "/saas/owner/cash-verify/generate"; // Go: owner-scoped port of legacy /cash-verify/generate
export const cashVerifyStatus = "/saas/owner/cash-verify/status"; // Go: owner-scoped port of legacy /cash-verify/status
export const cashVerifySession = "/saas/cash-verify/session"; // Go: public (token-auth) port of legacy /cash-verify/session
export const cashVerifySubmit = "/saas/cash-verify/submit";   // Go: public (token-auth) port of legacy /cash-verify/submit

// member
export const memberFitnessProfileGet = "/member/fitnessProfileLogs";
export const memberGet = "/member";
export const memberDelete = "/member/delete";
export const memberCreate = "/member/add";
export const memberUpdate = "/member/update";
export const memberDietUpdate = "/member/updateDiet";

// dietcat diettype
export const dietCatGet = "/dietcat/getall/new";
export const dietCatCreate = "/dietcat/add/";
export const dietTypeGet = "/diettype/getall";
export const dietGet = "/diet";

// diet package
export const dietPackageGet = "/dietcat/new";
// export const dietPackageGet = "/dietpackage";

// diet unit
export const dietUnitGet = "/dietunit/get";
export const dietUnitDelete = "/dietunit/delete?unitid=";
export const dietUnitCreate = "/dietunit/add";
export const dietUnitUpdate = "/dietunit/update/";

// user
export const user_get = "/user";

export const loginEndPoint = "/user/login";
export const walkinFollowupCreate = "/user/walkin/followup";
export const walkinRatingCreate = "/user/walkin/rating";
export const walkinEnquiryCreate = "/user/v2/enquiry";
export const walkinEnquiryGet = "/user/v2/enquiry";
export const userLeadsGet = "/user/leads";
export const userSignUp = "/user/mobile/signup";
export const userGet = "/user";
export const userCreate = "/user/add";
export const userUpdate = "/user/update";
export const userDelete = "/user/delete";
export const userWalkinUpdate = "/user/walkin/update";
export const userByIDGet = "/user/id";
export const forgetPassword = "/user/forgot";
export const resetPassword = "/user/reset";

export const chatBotBmi = "/chatbot/bmi";

// gym
export const dashboardGet = "/dashboard";
export const gymDashBoardReportsGet = "/gym/dashboard/reports/details/v2";
export const gymDashBoardReportGet = "/gym/dashboard/reports/v2";
export const gymPlans = "/gym/plan"; // this is a post api used to GET gym plans
export const gymsGet = "/saas/owner/gyms";

export const settlementCTOStatsGet = "/settelement/v2/cto/stats";

// ATTENDANCE
export const attendanceGet = "/attandance";

// Checkin Reports
export const checkinReports = "/staff/report";

// TRAINER ATTENDANCE GET
export const attendanceTrainerGet = "/staff/report";

// EXPORT
export const ptReports = "/ptTrial/subs_pt_trial_info";

// PT REPORTS - ASSIGNED TO MEMBER LOGS
export const assignedMembers = "/ptTrial/assigned_members_checkin_details";

// DASHBOARD CARDS - REGULAR | PT SALE VALUES
export const rptSaleValues = "/gym/stats/subscription-type";

// WORKOUT LOGS
export const workoutLogs = "/workoutmapping/workout/latest";

// BIOMAX MEMBERS
export const biomxMembers = "/subscription/subs_biomax_info";

// ACTIVE PT WITH EXPIRED SUBSCRIPTION
export const activePTwithExpSubsAPI = "/pt/regular_pt_subs_stats";

// TRAINER INFO
export const trainerInfo = "/pt/all_pt_trainer_details";

// CTO STATS
export const ctoStats = "/settelement/v2/cto/stats";

// TRAINER / MEMBER
export const trainerMember = "/trainer/default_trainer_members_details";

// GYM TARGET
export const gymTarget = "/settelement/v2/target";

// TRAINER REPORT FILTER TYPE WISE
export const getTrainerMemberReport = "/trainer/trainer_report_members_details";

// GYM TARGET
export const chartRevenueDetailNew = "/pt/chart_revenue_details";

// GET CENTALISED PLAN FEATURES
export const centralisedPlanFeatures = "/planFeature";

// GT PT TRAINER
export const gtptTrainersGet = "/pt/all_pt_trainer_details";
// keys --------------------------------------

export const draftAddons = "draftAddons";
export const getAddonEndpointKey = "getAddonEndpointKey";
export const addons = "addons";
export const sessionAddonGetKey = "sessionAddonGetKey";
export const addonCategories = "addonCategories";

export const plans_key = "plans";
export const all_plans_key = "mapAblePlansData";

export const draftOffersGetKey = "draftOffers";
export const offersGetKey = "offers";

export const workoutPackagesGetKey = "workoutPackagesGetKey";
export const workoutexpGetKey = "workoutexpGetKey";
export const workoutCategoryGetKey = "workoutCategoryGetKey";
export const workoutCategoryGetKeyAll = "workoutCategoryGetKeyAll";
export const workoutGetKey = "workoutGetKey";
export const workoutGetAllKey = "workoutGetAllKey";
export const workoutMappingStatsGetKey = "workoutMappingStatsGetKey";

export const enquiryV2GetKey = "enquiryV2GetKey";
export const userLeadsGetKey = "userLeadsGetKey";

export const subsGetByIdKey = "subsGetByIdKey";
export const subscriptionsGetByIdKey = "subscriptionsGetByIdKey";
export const subscriptionsGetKey = "subscriptionsGetKey";

export const subscriptionMemberKey = "subscriptionMemberKey";
export const workoutMappingGetKey = "workoutMappingGetKey";

export const trainerLevels = "trainerLevels";
export const trainersGetKey = "trainersGet";
export const trainerV2GetKey = "trainerGet";
export const trainerfeedbacksGetKey = "trainerfeedbacksGet";
export const trainerShiftKey = "trainerShiftKey";
export const walkinEnquiryGetKey = "walkinEnquiryGetKey";

export const usersGetKey = "usersGet";
export const userGetKey = "userGet";
export const userByIDGetKey = "userByIDGetKey";

export const memberFitnessProfileGetKey = "memberFitnessProfileGetKey";
export const memberGetKey = "memberGetKey";

export const dashboardGetKey = "dashboardGetKey";
export const gymDashBoardReportsGetKey = "gymDashBoardReportsGetKey";
export const gymDashBoardReportGetKey = "gymDashBoardReportGetKey";
export const gymsGetKey = "gymsGetKey";

export const ptIncentiveDraftGetKey = "ptIncentiveDraftGetKey";
export const ptIncentiveGetKey = "ptIncentiveGetKey";

export const dietCatGetKey = "dietCatGetKey";
export const dietTypeGetKey = "dietTypeGetKey";
export const dietGetKey = "dietGetKey";
export const dietUnitGetKey = "dietUnitGetKey";
export const dietPackageGetKey = "dietPackageGetKey";

export const settlementCTOStatsGetKey = "settelementCTOStatsGetKey";

// PT Track Export API
export const ptTrackDataExport = "/ptTrial/stats";

// POST | PUT | Delete
// Daily Target
export const dailyTargetPost = "/dailyTargetMatrix/add";
// Campaign
export const campaignSystem = "/campaign/add";
export const campaignSystemUpdate = "/campaign/update";
export const campaignSystemDelete = "/campaign/delete";

// Job
export const jobAdd = "/campaign/add";
export const initiatedCallDetails = "/campaign/get_logs";

// Centralised Plan Feature
export const deleteCentralisedPlanFeature = "/planFeature/delete";
export const addCentralisedPlanFeature = "/planFeature/add_multiple";
export const updateCentralisedPlanFeature = "/planFeature/update_multiple";

// Leave Management
export const addLeaveCategory = "/leaveManagement/category/add";
export const updateLeaveCategory = "/leaveManagement/category/update";
export const deleteLeaveCategory = "/leaveManagement/category/delete";

// Staff Leave Management
export const applyNewLeave = "/leaveManagement/apply_leave";
export const updateAppliedLeave = "/leaveManagement/apply_leave/update";
export const deleteAppliedLeave = "/leaveManagement/apply_leave/delete";

// Staff Salary Deducte
export const salaryDeductGet = "/leaveManagement/get_deducted_amount";

// Approve Leave
export const approveLeave = "/leaveManagement/approve_reject_leave";

// Delete Approval Manager
export const deleteApprovalManager = "/leaveManagement/approval_manager/delete";

// Add Approval Manager
export const addApprovalManager = "/leaveManagement/approval_manager/add";

// Update Approval Manager
export const updateApprovalManager = "/leaveManagement/approval_manager/update";

// LEAD MANAGEMENT
// Add New Lead
export const addLead = "/leads/v2";
export const addLeadFollowup = "/leads/follow-up/v2";
export const deleteUpdateLead = "/leads/v2";
export const assignRawLead = "/leads/assign/bulk";
export const exportLead = "/leads/v2";
export const leadCountDetails = "/leads/lead-count/details";
export const reAssignLeads = "/leads/assign/multiple";
export const CALL_DETAILS = "/leads/call_details";
export const CONVERTED_AUDIO = "/campaign/recording/access_link";
export const exportRawLead = "/leads/unassigned";
export const importRawLead = "/leads/raw/import";
export const sampleRawLeadCSV = "/leads/raw/sample-csv";
export const click_to_call_api = "/leads/click_to_call";
export const ivr_initiate_call = "/ivr/initiate-call";

// Agent Report | LMS
export const fd_task_sop = "/staff/agentwise_sop_report";

// Agent Mapping
export const mapAgent = "/campaign/mapMyoperatorAgent";
export const mapAgentBulk = "/campaign/mapMyoperatorAgent/bulk";
export const updateMappedAgent = "/campaign/mapMyoperatorAgent/update";
export const deleteMapping = "/campaign/mapMyoperatorAgent/delete";
export const otpRequestAPI = "/campaign/otp_request";
export const otpVerifyAPI = "/campaign/verify_otp";
export const otpRequestAPIMobile = "/user/mobile/otp?type=login";
export const otpVerifyAPIMobile = "/user/mobile/login";

export const otpRequestMobile = "/user/mobile/otp";
export const otpVerifyMobile = "/user/verify/otp/v2";
export const otpRequestEmail = "/user/email/otp";
export const otpVerifyEmail = "/user/verify/email/otp";

// Member Fitness Profile
export const fitnessProfileLogPut = "/member/fitnessProfileLogs";
export const memberUpdatePut = "/member/update";
export const dietMapping = "/dietmapping/assignpackage";

//  Followup System
export const addFollowup = "/leads/customer_intent_value/add";
export const updateFollowup = "/leads/customer_intent_value/update";

// Customer Intent
export const addCustomerIntent = "/leads/customer_intent/add";
export const updateCustomerIntent = "/leads/customer_intent/update";
export const deleteCustomerIntent = "/leads/customer_intent/delete";

// Workouts
export const workoutExercisesAdd = "/workout/new/add";
export const workoutExercisesUpdate = "/workout/new/update";
export const workoutExercisesDelete = "/workout/new/delete";
export const workoutExercisesGet = "/workout/new";

export const workoutEquipmentsDelete = "/equipment/new/delete";
export const workoutEquipmentsAdd = "/equipment/new/add";
export const workoutEquipmentsUpdate = "/equipment/new/update";

export const workoutPackageDeleteNew = "/workoutpackage/new/delete";
export const workoutPackAdd = "/workoutpackage/new/add";
export const workoutPackUpdate = "/workoutpackage/new/update";

// Website
export const deleteTestimonial = "/gym/vibe/delete";
export const addTestimonial = "/gym/vibe/add_multiple";
export const updateTestimonial = "/gym/vibe/update";

export const deleteCareer = "/career/delete";
export const updateCareer = "/career/update";
export const addCareer = "/career/add";

export const deleteWorkoutGoal = "/workout/goal/delete";
export const addWorkoutGoal = "/workout/goal/add";
export const updateWorkoutGoal = "/workout/goal/update";

// Incentives
export const deleteIncentiveTarget = "/incentive/target/delete";
export const addIncentiveTarget = "/incentive/target/add";
export const updateIncentiveTarget = "/incentive/target/update";
export const applicableSubscriptions = "/incentive/incentive_applicable_subs";

// Aggrement
export const aggrementLink = "/transaction/agreement";

// PT Members
export const ptMembers = "/pt/pt_members";

// Hygiene System
export const deleteHygieneTask = "/hygiene/task/delete";
export const addHygieneTask = "/hygiene/task/add";
export const updateHygieneTask = "/hygiene/task/update";

export const deleteHygieneCategory = "/hygiene/category/delete";
export const addHygieneCategory = "/hygiene/category/add";
export const updateHygieneCategory = "/hygiene/category/update";

export const add_hygiene_status = "/operation/task/status/add";
export const update_hygiene_status = "/operation/task/status/update";
export const delete_hygiene_status = "/operation/task/status/delete";

export const add_hygiene_task_freq = "/";
export const update_hygiene_task_freq = "/";
export const delete_hygiene_task_freq = "/";

export const add_hygiene_task = "/operation/task/add";
export const update_hygiene_task = "/operation/task/update";
export const delete_hygiene_task = "/operation/task/delete";

export const add_hygiene_logs = "/operation/task/submission";

export const add_hygiene_task_categories = "/operation/task/category/add";
export const update_hygiene_task_categories = "/operation/task/category/update";
export const delete_hygiene_task_status = "/operation/task/status/delete";
export const delete_hygiene_task_categories = "/operation/task/category/delete";

export const add_hygiene_approval = "/operation/breakdown/request/process";

export const approve_reject_hygine_task = "/operation/task/verification";

// Renewal Stat Detail
export const renewal_stat_detail = "/subscription/renewal_past_renewal";
export const datewise_renewals =
  "/subscription/datewise_expiring_renewals_unpaid_data";

// Cupon
export const apply_cupon = "/payment/coupon_request";

// Export Dashboard Cards
export const export_dashboard_reports_details_v2 =
  "/gym/dashboard/reports/details/v2";

// Trainer Member Engagement
export const trainer_member_engagement_form_submit = "/member_engagement/add";
export const update_trainer_member_engagement_form_submit =
  "/member_engagement/update";
export const delete_trainer_member_engagement_form_submit =
  "/member_engagement/delete";
export const approve_reject_engagement_request =
  "/member_engagement/approval_process";
export const delete_tme_approval_manager =
  "/member_engagement/approval_manager/delete";
export const add_approval_manager = "/member_engagement/approval_manager/add";
export const update_approval_manager =
  "/member_engagement/approval_manager/update";

// Trail Intro Done
export const trial_intro_done = "/ptTrial/trainer_intro/bulk";

// TV
export const deleteTv = "/gym_tv/delete";
export const updateTv = "/gym_tv/update";
export const addTv = "/gym_tv/add";

// TV Notification Stakeholder
export const tvStakeholderAdd = "/gym_tv/notify_stackholder/add";
export const tvStakeholderUpdate = "/gym_tv/notify_stackholder/update";
export const tvStakeholderDelete = "/gym_tv/notify_stackholder/delete";
export const tvStakeholderAdditionalAdd = "/gym_tv/additional_stakeholder";

export const additionalStakeholderDelete =
  "/gym_tv/additional_stakeholder/delete";
// Time Sheet
export const addTimeSheet = "/timesheetManagement/add";
export const updateTimeSheet = "/timesheetManagement/update";
export const approvalTimeSheet = "/timesheetManagement/approval_process";

// Calender View Attendance
export const cal_view_staff_attendance = "/staff/report/logs";

// CTO
export const add_cto_category = "/settelement/v2/cto/category";
export const update_cto_category = "/settelement/v2/cto/category";
export const delete_cto_category = "/settelement/v2/cto/category";

export const add_cto_head = "/settelement/v2/cto-heads";
export const update_cto_head = "/settelement/v2/cto-heads";
export const delete_cto_head = "/settelement/v2/cto-heads";

// PT Flow
export const pt_members = "/pt/pt_members";
export const pt_session = "/pt/session";
export const pt_trainer_details = "/pt/all_pt_trainer_details";
export const pt_sale_stat_detail = "/pt/pt_sales_stats/data";
export const pt_trial_3day = "/pt/three_days_trial";
export const exportTAEE = "/pt/pt_members";
export const export_expired_pt = "/pt/three_days_trial";

// Three Day PT Trial - Member Details and Stats
export const threeDayPTMemberDetails = "/ptTrial/threeday/member-details";
export const threeDayPTSessionStats = "/ptTrial/threeday/session-stats";

// Last Seen
export const last_seen = "/user/last_seen";

// Offer Mapping
export const offer_mapping_POST = "/plan/plan_offer/add";
export const offer_mapping_PUT = "/plan/plan_offer/update";
export const offer_mapping_DEL = "/plan/plan_offer/delete";

// PT Prospect
export const add_new_pt_prospect = "/leads/pt-prospect";
export const update_pt_prospect = "/leads/pt-prospect/update";

// Deffered Payments
export const add_df_payment = "/payment/deferred/add";
export const add_pt_df_payment = "/payment/pt_discount/add";
export const enable_fd_df_payment_creation = "/payment/dp_toggle";

export const approve_reject_couple_membership_request =
  "/payment/couple-plan/approval";

export const couple_post_deffered_payment_request = "/payment/couple-plan";

export const verify_discount_payment_request =
  "/payment/deferred/approval_process";

export const verify_discount_pt_payment_request =
  "/payment/pt_discount/approval_process";

// Expense Management
export const delete_expense_category = "/expense/category/delete";
export const add_expense_category = "/expense/category/add";
export const update_expense_category = "/expense/category/update";

export const delete_expense_process_manager = "/expense/process_manager/delete";
export const add_expense_process_manager = "/expense/process_manager/add";
export const update_expense_process_manager = "/expense/process_manager/update";

export const add_expense_request = "/expense/v2/add";
export const update_expense_request = "/expense/v2/update";
export const delete_expense_request = "/";

export const approve_reject_expense_request = "/expense/v2/approval_process";
export const pay_expense_request = "/expense/v2/payment_process";

// Trainer Incentives System
export const add_incentive_slab = "/incentive/slabs/add";
export const update_incentive_slab = "/incentive/slabs/update";
export const delete_incentive_slab = "/incentive/slabs/delete";
export const pt_session_details = "/incentive/session_details";
export const total_pt_sale_details = "/incentive/purchased_month_sale_details";

// Banner Image
export const add_banner_image = "/banner/add/new";
export const update_banner_image = "/banner/update";
export const delete_banner_image = "/banner/delete";
// WTF Banners (V4 — vertical/horizontal TV banner support)
export const get_banners_v4 = "/banner/v4";
export const delete_banner = "/banner/delete";
export const add_banner_v4 = "/banner/add/v4";
export const update_banner_v4 = "/banner/update/v4";

// Fitness Profile
export const fitness_profile_logs = "/user/fitness_profile_logs";
export const user_feedback_logs = "/user/all_feedbacks";

// One Day Membership
export const export_one_day = "/subscription/one_day_membership";
export const export_pending_one_day = "/subscription/one_day_membership_lead";

// Gym Benefits
export const delete_fitness_center = "/gym/delete";
export const update_gym_benefit = "/benefits/v2/map/gym";

// Ad Blogs
export const add_parent_blog_category = "/blog/main_category/add";
export const update_parent_blog_category = "/blog/main_category/update";
export const delete_parent_blog_category = "/blog/main_category/delete";

export const add_blog_category = "/blog/category/add";
export const update_blog_category = "/blog/category/update";
export const delete_blog_category = "/blog/category/delete";

export const add_blog = "/blog/article/add";
export const update_blog = "/blog/article/update";
export const delete_blog = "/blog/article/delete";

// Dashboard Contents
export const add_update_delete_dash_menu = "/admin/menu";

export const add_update_delete_dash_feature = "/admin";

export const add_feature_map = "/admin/assign";
export const delete_feature_map = "/admin/feature/user";

export const add_feature_grouping = "/admin/feature_group/add";
export const update_feature_grouping = "/admin/feature_group/update";
export const delete_feature_grouping = "/admin/feature_group/delete";

export const map_feature_group_with_user = "/admin/feature_group/map";

// Import Members
export const approve_reject_import_member_req = "/member/approval_process";
export const del_import_member_req = "/member/import_approval_data/delete";

// PT Transfer
export const post_pt_transfer = "/pt/transfer_pt";
export const pt_transfer_history = "/pt/transfer_pt/log";

// BTL
export const del_BTL_vendor = "/leads/btl/vendor/delete";
export const add_BTL_vendor = "/leads/btl/vendor/add";
export const update_BTL_vendor = "/leads/btl/vendor/update";

// Upgrade Membership
export const post_upgrade_membership = "/subscription/upgrade_membership";

// Upgrade PT (addon_pt) Membership — ported from main
export const post_upgrade_pt_membership = "/subscription/upgrade_pt_membership";

// All Access Pass
export const add_all_access_category = "/plan/allaccess_category/add";
export const update_all_access_category = "/plan/allaccess_category/update";
export const delete_all_access_category = "/plan/allaccess_category/delete";

// Dashboard Documentations
export const add_docs = "/gym/feature_guide/add";
export const update_docs = "/gym/feature_guide/update";
export const delete_docs = "/gym/feature_guide/delete";

export const add_feedback = "/gym/feature_feedback/add";
export const update_feedback = "/gym/feature_feedback/update";
export const delete_feedback = "/gym/feature_feedback/delete";

// Gym Plans
export const add_gym_plans = "/plan/gym_plan_price/add";
export const update_gym_plans = "/plan/gym_plan_price/update";
export const delete_gym_plans = "/plan/gym_plan_price/delete";

// Fitness Center
export const add_gym = "/gym/add";
export const update_gym = "/gym/update";
export const update_gym_thumbnail_cover_image = "/gym/media/update";

// Staff Onboarding
export const add_staff_onboarding = "/staff";
export const update_staff_onboarding = "/staff";
export const delete_staff_onboarding = "/staff";

export const update_staff_register = "/staff/register";

export const update_trainer = "/trainer/update";

export const add_staff_cto = "/staff/cto/add";

export const delete_user = "/user/delete/all";

export const re_onboard_staff = "/staff/re-onboard";

// Staff Off-Boarding (Full & Final settlement)
export const staff_off_boarding = "/staff-offboarding/add";
export const staff_off_boarding_get_all = "/staff-offboarding";
export const staff_off_boarding_update = "/staff-offboarding/update";

// Version
export const addVersion = "/version/add";

// Gallery
export const add_gallery = "/gallery/add";
export const delete_gallery = "/gallery/delete";

// Wtf Benefits add
export const add_wtf_benefits = "/benefits/v2/add";
export const update_wtf_benefits = "/benefits/v2/update";

// Schedule Notification
export const add_schedule_notification = "/notification/scheduleNew";
export const add_immediate_notification = "/notification/add";
export const delete_notification = "/notification/delete";
export const update_notification = "/notification/update";
export const upload_file = "/notification/upload";

// Gym Plans
export const add_gym_location = "/gym/places/v2";
export const update_gym_location = "/gym/location";
export const delete_gym_location = "/gym/location";

export const map_gym_location = "/gym/map-location";

export const update_gym_cities_metadata = "/gym/cities/meta";

// Training
export const add_update_dalete_training = "/training";

// Receptionist
export const add_receptionist = "/user/receptionist";
export const update_receptionist = "/user/receptionist";
export const delete_receptionist = "/user/receptionist";

// Reward
export const total_balance_left = "/reward/balance";
export const coins_spent = "/reward/coins_spent/stats";
export const coins_spent_details = "/reward/coins_spent/details";

export const earning_tasks = "/coins/earning_modes";
export const updateEarningTask = "/coins/earning_modes/update";

// Gym Feedback
export const resolve_gym_feedback_issue = "/feedback/gym-feedback";

// Metabase
export const add_metabse_links = "/metabase/add";
export const update_metabse_links = "/metabase/update";
export const delete_metabse_links = "/metabase/delete";

// Branch IO | Dynamic Linking
export const generate_dynamic_link = "/dynamic/generate/v2";

// Gym Landing Page
export const delete_gym_landing_page = "/gym/lp/delete-url";
export const add_gym_landing_page = "/gym/lp/add-url";
export const update_gym_landing_page = "/gym/lp/update-url";

// Website Tab Peference
export const add_website_tab_preference = "/plan/tab-preferences";

// Centralised Plan Categories
export const delete_centralised_plan_category = "/gym/category/delete";
export const add_centralised_plan_category = "/gym/category/add";
export const update_centralised_plan_category = "/gym/category/update";

// Gym Alias
export const add_gym_alias = "/gym/alias";
export const update_gym_alias = "/gym/alias";
export const delete_gym_alias = "/gym/alias/delete";

// Gym ODM
export const gym_odm_lead_capture_toggle = "/gym/odm-lead-capture-toggle";
export const odm_update_gym_id = "/subscription/one_day_membership_lead/update_gym_id";

// WTF 360
export const wtf_360_inquiry = "/wtf-main/inquiry";

export const coins_earned_vs_spent = "/reward/coins/stats";
export const top_users = "/reward/top_users";
export const top_gyms = "/reward/top_gyms";
export const top_users_details = "/reward/by_user";

// Academy
export const top_courses = "/academy/course";
export const add_course = "/academy/course/add";
export const update_course = "/academy/course/update";
export const delete_academy_course = "/academy/course/delete";

export const academy_course_categories = "/academy/course/category";
export const delete_academy_course_categories =
  "/academy/course/category/delete";
export const add_academy_course_category = "/academy/course/category/add";
export const update_academy_course_category = "/academy/course/category/update";

// Course Schedule Endpoints
export const academy_course_schedule = "/academy/course/schedule";
export const add_academy_course_schedule = "/academy/course/schedule/add";
export const update_academy_course_schedule = "/academy/course/schedule/update";
export const delete_academy_course_schedule = "/academy/course/schedule/delete";

// Team Management
export const get_team_members = "/user/team-members";
export const add_team_member = "/user/team-members";
export const update_team_member = "/user/team-members";
export const delete_team_member = "/user/team-members";

export const get_team_departments = "/user/team-department";
export const add_team_department = "/user/team-department";
export const update_team_department = "/user/team-department";
export const delete_team_department = "/user/team-department";

// Investor Management
export const get_investors = "/user/investors";
export const add_investor = "/user/investor";
export const update_investor = "/user/investor";
export const delete_investor = "/user/investor";

// Member import endpoint
export const memberImport = "/member/importUsers";
export const memberImportV2 = "/member/importUsers/v2";

export const expense_stats = "/expense/v2?is_card_stats=1";
export const petty_cash_stats = "/expense/petty_cash/stats";
export const petty_cash_lists = "/expense/v2?is_petty_cash=1";
export const cluster_manager_petty_cash = "/expense/cm_list";

// Vendor Management
export const get_vendors = "/expense/vendor";
export const add_vendor = "/expense/vendor/add";
export const update_vendor = "/expense/vendor/update";
export const delete_vendor = "/expense/vendor/delete";
export const expense_timeline = "/expense/timeline";
export const expense_top_paid = "/expense/top-paid";
export const expense_top_gyms_spend = "/expense/top-gyms-spend";
export const expense_month_trend = "/expense/month-trend";
export const expense_top_category_spend = "/expense/top-category-spend";
export const expense_pending_fd_vendor = "/expense/pending-fd-vendor";
export const get_devices = "/gym/device/get";
export const update_device_id = "/gym/update-or-insert";

// Ticket System
export const ticket_user_roles = "/ticketSystem/role";
export const ticket_user_enum = "/ticketSystem/role/user";
export const ticket_user_role_mapping = "/ticketSystem/role-mapping";
export const ticket_user_role_delete = "/ticketSystem/role-mapping/delete";

// TICKET SYSTEM
export const ticketSystem = "/ticketSystem";
export const ticketSystemStats = "/ticketSystem/stats";
export const ticketSystemStart = "/ticketSystem/start";
export const ticketSystemComplete = "/ticketSystem/complete";
export const ticketSystemTat = "/ticketSystem/tat";

// TICKET SYSTEM ANALYTICS
export const ticketSystemGymwiseStats = "/ticketSystem/gymwise-ticket";
export const ticketSystemCategoryDistribution =
  "/ticketSystem/category-distribution-stats";
export const ticketSystemInfraSpend = "/ticketSystem/gymwise-infra-spend";
export const ticketSystemTatTrend = "/ticketSystem/average-tat-trend";
export const ticketSystemSupervisorPerformance =
  "/ticketSystem/supervisor-performance_heatmap";
export const ticketSystemPaidResolutionTracker =
  "/ticketSystem/paid-resolution-tracker";

// TICKET SYSTEM RESOLVE
export const ticketSystemResolve = "/ticketSystem/resolve";

// TICKET SYSTEM VERIFICATION
export const ticketSystemVerify = "/ticketSystem/verify";

export const ticketSystemAssign = "/ticketSystem/assign";
export const ticketSystemCategories = "/ticketSystem/category";

export const ticketSystemStartWork = "/ticketSystem/start";

export const ticketSystemSlaRules = "/ticketSystem/sla-rules";

// BREAK RULES ENDPOINTS
export const trackingSystemBreakRules = "/user/breaks";
export const trackingSystemBreakLogs = "/user/break-logs";
export const trackingSystemLocationLogs = "/user/location-logs";
export const trackingSystemAttendanceLogs = "/user/workday/summary";

// Sendy List Verification
export const sendyListVerify = "/wati/sendy-list";

// FD Incentives
export const add_fd_incentive_slab = "/incentive/fd/slab/add";
export const update_fd_incentive_slab = "/incentive/fd/slab/update";

// What's New endpoints (ported from main)
export const getWhatsNew = "/whatNew/getAll";
export const addWhatsNew = "/whatNew/add";
export const updateWhatsNew = "/whatNew/update";
export const deleteWhatsNew = "/whatNew/delete";
export const whatNewUploadConfig = "/whatNew/upload-config";
